module.exports = __webpack_public_path__ + "static/img/p2.4b659d63.png";